/* Card gateways, manual card entry, card TDR and card validation.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";
const CryptoJS = require("crypto-js");
import { base_url } from "../../pg_url";

export default {
  methods: {

    checkMonthYearValidity() {
      let val = this.editedItem.mm_yy;
      let month_length = val.length;

      if (month_length == 1) {
        if (val >= "2" && val <= "9") {
          this.editedItem.mm_yy = "0" + val + "/";
        }
      }

      if (month_length == 3) {
        let remove_char = val.slice(0, -1);
        if (remove_char >= 13 || remove_char == "00") {
          this.editedItem.mm_yy = "";
        }
      }

      if (month_length == 5) {
        let rem_year = val.slice(-2);
        let previous_str = val.slice(0, -3);
        let current_year = new Date()
          .getFullYear()
          .toString()
          .substr(-2);
        if (rem_year < current_year) {
          this.editedItem.mm_yy = previous_str;
        } else {
          document.getElementById("cvc_cvv").focus();
        }
      }
    },

    save_card_info() {
      var CryptoJSAesJson = {
        stringify: function(cipherParams) {
          var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
          if (cipherParams.iv) j.iv = cipherParams.iv.toString();
          if (cipherParams.salt) j.s = cipherParams.salt.toString();
          return JSON.stringify(j);
        },
      };
      var key = this.$route.query.order_id;

      var emi_str = this.editedItem.emi;
      var wordpos = emi_str.search("months");
      var emi_month = emi_str.substring(0, wordpos - 1);
      var emi_amt = emi_str.substring(wordpos + 7, emi_str.length);
      let selectedCardStatus = this.isSelectedCard;

      if (selectedCardStatus === true) {
        var sp_login_status = this.getCookie("token");
        var engine_token = this.$route.query.token;
        var orderid = this.$route.query.order_id;
        //var amount = this.sp_amount;
        var amount;
        var cof_payable_amt = this.payable_amt;
        if (cof_payable_amt > 0) {
          amount = cof_payable_amt;
        } else {
          amount = this.sp_amount;
        }

        var card_number1 = this.editedItem.card_number;
        var card_number_space_remove = card_number1.replace(/ /g, "");
        var card_number = CryptoJS.AES.encrypt(
          JSON.stringify(card_number_space_remove),
          key,
          { format: CryptoJSAesJson }
        ).toString();

        var expdate1 = this.editedItem.mm_yy;
        var expdate = CryptoJS.AES.encrypt(JSON.stringify(expdate1), key, {
          format: CryptoJSAesJson,
        }).toString();

        var cvv_cvc1 = this.editedItem.cvc_cvv;
        var cvv_cvc = CryptoJS.AES.encrypt(JSON.stringify(cvv_cvc1), key, {
          format: CryptoJSAesJson,
        }).toString();

        var card_holder_name1 = this.editedItem.card_holder_name;
        var card_holder_name = CryptoJS.AES.encrypt(
          JSON.stringify(card_holder_name1),
          key,
          { format: CryptoJSAesJson }
        ).toString();

        var card_name = this.user_entered_card_name;
        var is_save_card;
        var store_id = this.store_id;

        if (this.checkbox == true) {
          is_save_card = "1";
        } else {
          is_save_card = "0";
        }

        /*
         **if the user is not logged in then....
         **isLoggedin value is null
         **mobile_no value is null
         */
        if (
          sp_login_status === "" ||
          (sp_login_status !== "" && is_save_card == 0)
        ) {
          //New changes 01/09/2021
          var c_token = this.getCookie("token");
          if (c_token !== "") {
            customer_token = c_token;
          } else {
            customer_token = "";
          }

          const options = {
            method: "POST",
            url: this.base_url + "pay-now",
            headers: {
              Authorization: "Bearer " + engine_token,
            },
            data: {
              card_number,
              expdate,
              cvv_cvc,
              card_holder_name,
              card_name,
              orderid,
              amount,
              is_save_card,
              store_id,
              customer_token,
            },
          };

          axios
            .request(options)
            .then((response) => {
              const payload = response.data.original || response.data;
              if (payload.message == 1 && payload.url) {
                window.location.href = payload.url;
              } else if (payload.sp_code == "200" && payload.url) {
                console.log(response);
                window.location.href = payload.url;
              } else if (payload.sp_code == "424") {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = payload.message;
              } else if (payload.sp_code == "104") {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = payload.message;
              } else {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = "Something went wrong";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
        //sp_login_status null if end

        /*
         * when sp_login_status is set
         */

        if (sp_login_status !== "" && is_save_card == 1) {
          var customer_token = this.getCookie("token");
          const options = {
            method: "POST",
            url: this.customer_api_base_url + "save-and-pay-now",
            headers: {
              Authorization: "Bearer " + customer_token,
            },
            data: {
              card_number,
              expdate,
              cvv_cvc,
              card_holder_name,
              card_name,
              orderid,
              amount,
              is_save_card,
              store_id,
              engine_token,
            },
          };

          axios
            .request(options)
            .then((response) => {
              if (response.data.sp_code == "200") {
                this.snackbar = true;
                this.color = "#0F9750";
                this.timeout = 2000;
                this.popup_text = "Card saved successful.";
                window.location.href = response.data.url;
              } else if (response.data.sp_code == "424") {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = response.data.message;
              } else if (response.data.sp_code == "104") {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = response.data.message;
              } else {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = "Something went wrong";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
        //sp_login_status is not null if end
      } //selectedCardStatus if end
      else if (selectedCardStatus === false) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Enter a Valid Card number";
        this.editedItem.card_number = "";
      }
    },

    openCardForm() {
      this.saved_card_tab1 = true;
      this.card_tab = false;
    },

    /**
     * Cards Payment
     * 1)With TDR
     * 2)Without TDR
     */

    tdrComissionInfoCards(card_name, store_id, gateway_id, gateway_type_id) {
      var sp_token = this.$route.query.token;
      var amount = this.sp_amount;
      const options = {
        method: "POST",
        url: this.base_url + "v1/landing/surcharge",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: { amount, store_id, gateway_id },
      };
      axios
        .request(options)
        .then((response) => {
          var isSurchargeEnable = response.data.isSuccess;

          if (
            isSurchargeEnable === true &&
            response.data.response.isSurcharge === true
          ) {
            this.additional_fees_amt = response.data.response.commSurcharge;
            this.payable_amt = response.data.response.debitAmount;

            this.tdr_visibility = this.is_add_commission;
            this.tdr_visibility_pay_now_btn = this.is_add_commission;
            this.normal_user = 0;

            this.gateway_type_id_tdr = gateway_type_id;
            this.card_name_tdr = card_name;
          } else {
            this.tdr_visibility = 0;
            this.tdr_visibility_pay_now_btn = 0;
            this.normal_user = 1;
            this.payable_amt = 0;
            this.gateway_type_id_tdr = gateway_type_id;
            this.goDirectCardsGateWay(card_name);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    emiTdrCommisionInfoCards(card_name, store_id, gateway_id, gateway_type_id) {
      var sp_token = this.$route.query.token;
      var amount = this.sp_amount;
      var order_id = this.sp_orderid;
      const queryString = `?amount=${amount}&order_id=${order_id}&store_id=${store_id}&gateway_id=${gateway_id}`;

      // Concatenate the query string with the base URL
      const url = base_url + "v1/landing/emi" + queryString;
      const options = {
        method: "GET",
        url: url,
        headers: {
          Authorization: "Bearer " + sp_token,
        },
      };
      axios
        .request(options)
        .then((response) => {
          console.log(response.data);
          this.additional_fees_amt = 0;

          const emiChargeVal = parseFloat(response.data.emiCharge);
          const tdrChargeVal = parseFloat(response.data.tdrCharge);

          if (response.data.isEmiCharge) {
            this.additional_fees_amt = this.additional_fees_amt + emiChargeVal;
          }

          if (response.data.isTdr) {
            this.additional_fees_amt = this.additional_fees_amt + tdrChargeVal;
          }

          this.payable_amt = response.data.totalAmountPayable;

          this.tdr_visibility = this.is_add_commission;
          //this.tdr_visibility_pay_now_btn = this.is_add_commission;
          //this.tdr_visibility_pay_now_btn = 1;

          this.normal_user = 0;

          this.gateway_type_id_tdr = gateway_type_id;
          this.card_name_tdr = card_name;
          if (!response.data.isEmiCharge && !response.data.isTdr) {
            this.goDirectCardsGateWay(card_name);
          } else {
            this.tdr_visibility = 1;
            this.tdr_visibility_pay_now_btn = 1;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    ForwardCardGateway(card_name, gateway_id, gateway_type_id) {
      var store_id = this.store_id;
      var is_add_commission_tdr = this.is_add_commission;

      if (this.isTransactionEMI == 1) {
        this.emiTdrCommisionInfoCards(
          card_name,
          store_id,
          gateway_id,
          gateway_type_id
        );
      } else {
        if (is_add_commission_tdr == 1) {
          //console.log("is_add_commission enabled");
          this.tdrComissionInfoCards(
            card_name,
            store_id,
            gateway_id,
            gateway_type_id
          );
        } else {
          //console.log("No is_add_commission enabled");
          this.goDirectCardsGateWay(card_name);
        }
      }
    },

    goDirectCardsGateWay(card_name) {
      if (card_name === "") {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 6000;
        this.popup_text = "No card name is found.";
      }
      if (card_name !== "") {
        var payable_amount2 = this.payable_amt;
        var amount;

        if (payable_amount2 > 0) {
          amount = payable_amount2;
        } else {
          amount = this.sp_amount;
        }

        if (amount < 10) {
          this.snackbar = true;
          this.color = "red";
          this.timeout = 3000;
          this.popup_text = "Amount Cannot be less than 10 Taka.";
        } else {
          this.loading_tab = true;
          this.loading_dialog = true;
          var store_id = this.store_id;
          var orderid = this.$route.query.order_id;
          var emi_str = this.editedItem.emi;
          var wordpos = emi_str.search("months");
          var emi_month = emi_str.substring(0, wordpos - 1);
          var emi_amt = emi_str.substring(wordpos + 7, emi_str.length);
          var sp_token = this.$route.query.token;
          var invoiceno = this.invoiceno;
          const options = {
            method: "POST",
            url: this.base_url + "only-card-pay",
            headers: {
              Authorization: "Bearer " + sp_token,
            },
            data: {
              card_name,
              store_id,
              orderid,
              emi_month,
              emi_amt,
              invoiceno,
            },
          };
          axios
            .request(options)
            .then((response) => {
              if (response.data.message == 1) {
                this.loading_tab = false;
                this.loading_dialog = false;
                window.location.href = response.data.url;
              } else if (response.data.message == 5) {
                document.open();
                document.write(response.data.url);         // HTML display
                document.close();
              } else {
                this.loading_tab = false;
                this.loading_dialog = false;
                this.snackbar = true;
                this.color = "red";
                this.timeout = 3000;
                this.popup_text = "Something went wrong";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    goCardGateway(card_name, gateway_id, gateway_type_id) {
      this.cards_selected_gateway_iddd = gateway_id;
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.ForwardCardGateway(card_name, gateway_id, gateway_type_id);
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //checked when clicked
    show_cards(from_where_call) {

      this.showCreateAccountForm = false;
      this.showCOFRegisterOTPForm = false;
      this.is_cof_form_enable = true;
      this.is_cof_form_enable_terms = true;
      this.is_cof_form_enable_btn = true;
      this.is_cof_form_enable_btn2 = false;
      this.is_mask_card_enable = false;
      this.isCheckLoginEnable = true;
      this.isFormValidNew = false;
      this.AccountActiveDeactiveDiv = false;

      //New changes
      var card_number_without_space = this.editedItem.card_number.replace(
        /\s/g,
        ""
      );
      if (card_number_without_space.length >= 6) {
        this.CheckCardOnFileTdr();
      }
      this.checkbox = false;
      this.isCOFLoginFormEnable = false;

      this.isFormValid2 = false;
      this.selectedCvvIndex = null;
      this.CheckLoginFunction();
      var passStoreID = this.store_id;
      this.cardSkeletonLoader = false;
      this.mobile_banking = false;
      this.i_banking = false;
      this.user_account = false;
      this.loading_tab = false;
      this.loading_dialog = false;
      this.tdr_visibility = 0;
      this.tdr_visibility_pay_now_btn = 0;
      this.normal_user = 1;
      this.payable_amt = 0;
      this.cof_pay_now_btn_label = "Pay Now";
      this.saved_card_paynow_label = "Pay Now";

      this.merchant_gateway(1);
      this.cards_selected_gateway_iddd = 0;
      this.mfs_selected_gateway_iddd = 0;
      this.ibanking_selected_gateway_iddd = 0;

      if (this.loginBool == 1 && this.is_card_on_file_active == 1) {
        var total_saved_card = this.cardList.length;

        if (total_saved_card > 0) {
          if (from_where_call == "2") {
            this.card_tab = false;
            this.other_cards_display = false;
            this.saved_card_list = false;
            this.deleteCardConfirmationDialog = false;
            this.deleteConfirmationCard = false;

            this.hideCard_div = true;
            this.hidecardmenu = true;
            this.hideshowpaynow = true;
            this.saved_card_tab1 = true;
            this.fastPayStatus = true;
            this.saved_card_section = false;
          } else {
            this.saved_card_list = true;
            this.hideCard_div = false;
            this.hidecardmenu = false;
            this.hideshowpaynow = false;
            this.other_cards_display = false;

            this.cardList = "";
            var customer_token = this.getCookie("token");

            if (customer_token !== "") {
              const options = {
                method: "GET",
                url: this.customer_api_base_url + "show-card-info-list",
                headers: {
                  Authorization: "Bearer " + customer_token,
                },
              };

              axios
                .request(options)
                .then((response) => {
                  // When the response is success
                  if (response.data.sp_code == "200") {
                    this.cardList = response.data.card_data;
                    this.isShowStaticPart = true;
                  }

                  // When no card data saved
                  else if (response.data.sp_code == "204") {
                    this.showCofManualCardForm();
                    this.isShowStaticPart = false;
                  }

                  // Authentication problem
                  else if (response.data.sp_code == "1064") {
                    this.showCofManualCardForm();
                    this.snackbar = true;
                    this.color = "error";
                    this.timeout = 2000;
                    this.popup_text = "Authentication Problem";
                    this.isShowStaticPart = false;
                  } else {
                    this.showCofManualCardForm();
                    this.isShowStaticPart = false;
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
        } else if (from_where_call == "2") {
          this.showCofManualCardForm();
        } else {
          // cardList not loaded yet (e.g. landing tab was mWallet) — fetch before deciding UI
          this.SavedcardsAction();
        }
      } else if (this.loginBool == 0 && this.is_card_on_file_active == 1) {
        this.card_tab = false;
        this.other_cards_display = false;
        this.saved_card_list = false;
        this.deleteCardConfirmationDialog = false;
        this.deleteConfirmationCard = false;

        this.hideCard_div = true;
        this.hidecardmenu = true;
        this.hideshowpaynow = true;
        this.saved_card_tab1 = true;
        this.fastPayStatus = true;
        this.saved_card_section = false;
      } else {
        if (from_where_call == "emi") {
          this.card_tab = false;
          this.emi_tab = true;
          this.emiPopUp = true;
          this.other_cards_display = false;

          this.saved_card_list = false;
          this.deleteCardConfirmationDialog = false;
          this.deleteConfirmationCard = false;

          this.hideCard_div = false;
          this.hidecardmenu = false;
          this.hideshowpaynow = false;
          this.saved_card_tab1 = false;
          this.fastPayStatus = false;
          this.saved_card_section = false;
        } else {
          this.card_tab = true;
          this.emi_tab = false;
          this.other_cards_display = false;

          this.saved_card_list = false;
          this.deleteCardConfirmationDialog = false;
          this.deleteConfirmationCard = false;

          this.hideCard_div = false;
          this.hidecardmenu = false;
          this.hideshowpaynow = false;
          this.saved_card_tab1 = false;
          this.fastPayStatus = false;
          this.saved_card_section = false;
        }
      }
    },

    //later
    othersCard() {
      var enable_other_card_list = [];
      var total_cards_gateway = this.cards_gateways.length;

      for (let i = 0; i < total_cards_gateway; i++) {
        if (
          this.cards_gateways[i].gateway_id == 11 ||
          this.cards_gateways[i].gateway_id == 12 ||
          this.cards_gateways[i].gateway_id == 13
        ) {
          enable_other_card_list.push(this.cards_gateways[i]);
        }
      }

      for (let i = 0; i < total_cards_gateway; i++) {
        if (this.cards_gateways[i].gateway_id == 6) {
          enable_other_card_list.push(this.cards_gateways[i]);
        }
      }

      this.selected_other_card_list = enable_other_card_list;

      this.is_cof_form_enable_btn2 = false;
      this.is_mask_card_enable = false;
      this.isCOFLoginFormEnable = false;

      this.other_cards_display = true;
      this.hideCard_div = false;
      this.hidecardmenu = false;
      this.hideshowpaynow = false;
      this.AccountActiveDeactiveDiv = false;
    },

    showCofManualCardForm() {
      this.card_tab = false;
      this.other_cards_display = false;
      this.saved_card_list = false;
      this.deleteCardConfirmationDialog = false;
      this.deleteConfirmationCard = false;
      this.hideCard_div = true;
      this.hidecardmenu = true;
      this.hideshowpaynow = true;
      this.saved_card_tab1 = true;
      this.fastPayStatus = true;
      this.saved_card_section = false;
    },

    //no need
    show_card_form() {
      this.saved_card_tab1 = true;
      this.card_tab = false;
    },

    //no need
    select_card_icon(val) {
      let first_digit = val.charAt(0);
      let second_digit = val.charAt(1);
      let first_two_digit = val.substring(0, 2);

      if (first_two_digit == 34 || first_two_digit == 37) {
        // this.amexDeactive = false;
        // this.amexActive = true;

        // this.visaDeactive=true;
        // this.visaActive=false;

        // this.masterCardDeactive=true;
        // this.masterCardActive=false;

        // this.unionpayDeactive=true;
        // this.unionpayActive=false;

        // this.dinersDeactive=true;
        // this.dinersActive=false;

        // this.user_entered_card_name ="american-express";
        // this.isSelectedCard = true;

        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Please enter a valid card number";
        this.isSelectedCard = false;
      }

      if (
        first_digit == 3 &&
        (second_digit == 0 || second_digit == 6 || second_digit == 8)
      ) {
        // this.dinersActive = true;
        // this.dinersDeactive = false;
        // this.user_entered_card_name = "dinners-club";
        // this.isSelectedCard = true;

        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Please enter a valid card number";
        this.isSelectedCard = false;
      }

      if (first_digit == 4) {
        this.visaDeactive = false;
        this.visaActive = true;

        this.masterCardDeactive = true;
        this.masterCardActive = false;

        this.amexDeactive = true;
        this.amexActive = false;

        this.unionpayDeactive = true;
        this.unionpayActive = false;

        this.dinersDeactive = true;
        this.dinersActive = false;

        this.user_entered_card_name = "visa";
        this.isSelectedCard = true;
      }

      if (
        (first_digit == 5 && second_digit >= 1 && second_digit <= 5) ||
        (first_digit == 2 && second_digit >= 2 && second_digit <= 7)
      ) {
        this.masterCardDeactive = false;
        this.masterCardActive = true;

        this.visaDeactive = true;
        this.visaActive = false;

        this.amexDeactive = true;
        this.amexActive = false;

        this.unionpayDeactive = true;
        this.unionpayActive = false;

        this.dinersDeactive = true;
        this.dinersActive = false;

        this.user_entered_card_name = "master";
        this.isSelectedCard = true;
      }

      // if(first_digit==6){
      //   this.unionpayDeactive=false;
      //   this.unionpayActive=true;
      //   this.user_entered_card_name="union-pay";
      //   this.isSelectedCard = true;
      // }

      if (
        first_digit == 0 ||
        first_digit == 1 ||
        first_digit == 7 ||
        first_digit == 8 ||
        first_digit == 9 ||
        first_digit == 6
      ) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Please enter a valid card number";
        this.isSelectedCard = false;

        this.masterCardDeactive = false;
        this.masterCardActive = true;
        this.visaDeactive = false;
        this.visaActive = true;
        this.amexDeactive = false;
        this.amexActive = true;
        this.unionpayDeactive = false;
        this.unionpayActive = true;
        this.dinersDeactive = false;
        this.dinersActive = true;
      }
    },

    ValidateCardUsingLuhnAlgorith() {
      var cardNo = this.editedItem.card_number.replace(/\s/g, "");
      let nDigits = cardNo.length;
      let nSum = 0;
      let isSecond = false;
      for (let i = nDigits - 1; i >= 0; i--) {
        let d = cardNo[i].charCodeAt() - "0".charCodeAt();
        if (isSecond == true) d = d * 2;
        nSum += parseInt(d / 10, 10);
        nSum += d % 10;
        isSecond = !isSecond;
      }
      return nSum % 10 == 0;
    },
  },
};
